<template lang="pug">
  .component-split-payment-configuration
    .row(v-for="elem, index in value")
      DeleteConf(@click="value.splice(index, 1)")
      .column(v-for="val, inx in elem")
        SelectizeClientType(v-if="inx === 'client_type_id'", @optionSelected="setClientType($event, value[index])", :selectedValue="value[index][inx]")
        select(v-if="inx === 'esigibilita_iva'", v-model="value[index][inx]")
          option(value="I") Immediata (I)
          option(value="S") Split Payment (S)
        select(v-else-if="inx === 'formato_trasmissione'", v-model="value[index][inx]")
          option(value="FPR12") Formato Privato (FPR12)
          option(value="FPA12") Formato PA (FPA12)
        select(v-else-if="inx === 'modalita_pagamento'", v-model="value[index][inx]")
          option(value="MP05") Bonifico (MP05)
          option(value="MP08") Carta di Credito (MP08)
</template>

<script>
  import SelectizeClientType from '../../structure/ui/lists/selectize/SelectizeClientType'
  import DeleteConf from './DeleteConf'

  export default {
    name: 'ItalianEInvoiceSplitPaymentConfiguration',
    components: {DeleteConf, SelectizeClientType},
    methods: {
      setClientType(obj, value) {
        value.client_type_id = obj.id
      }
    },
    props: ['value', 'item']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ItalianEInvoiceSplitPaymentConfiguration.vue?c2fb1944